import React from "react";
import { LoadingOverlay } from "./LoadingOverlay";
import { ReviewHeader } from "./ReviewHeader";
import { SelectedParagraph } from "./SelectedParagraph";
import "./Review.css";

import type { ReviewHeaderProps } from "./ReviewHeader";
import type { SelectedParagraphProps } from "./SelectedParagraph";

/** Base handler types that can be reused across components */
export interface ReviewHandlers {
  onApprove?: () => Promise<void>;
  onApproveAll?: () => Promise<void>;
  onPrevious?: () => Promise<void>;
  onNext?: () => Promise<void>;
  onRestyle?: (newStyle: string) => Promise<void>;
  onRestyleAll?: (newStyle: string) => Promise<void>;
}

export interface ReviewProps extends ReviewHeaderProps, SelectedParagraphProps, ReviewHandlers {
  loading?: boolean;
}

export function Review(props: React.PropsWithChildren<ReviewProps>) {
  return (
    <div className="review">
      <ReviewHeader
        ignoreParagraphs={props.ignoreParagraphs}
        loading={props.loading}
        selectedCharacterStyleFilter={props.selectedCharacterStyleFilter}
        selectedGroupFilter={props.selectedGroupFilter}
        selectedStyleFilter={props.selectedStyleFilter}
        onClearCharacterStyle={props.onClearCharacterStyle}
        onClearGroup={props.onClearGroup}
        onClearStyle={props.onClearStyle}
        setIgnoreParagraphs={props.setIgnoreParagraphs}
      />
      <div className="review-controls">
        {props.loading && <LoadingOverlay />}
        <SelectedParagraph
          isMultiSelect={props.isMultiSelect}
          loading={props.loading}
          noSelectedCharacterStyle={props.noSelectedCharacterStyle}
          notInProfile={props.notInProfile}
          nextDisabled={props.nextDisabled}
          outlineMode={props.outlineMode}
          previousDisabled={props.previousDisabled}
          restyleAllStyle={
            props.outlineMode === "character"
              ? props.selectedCharacterStyleFilter
              : props.selectedStyleFilter
          }
          selectionBounds={props.selectionBounds}
          selectedItem={props.selectedItem}
          selectedStyle={props.selectedStyle}
          total={props.total}
          totalTracked={props.totalTracked}
          tracked={props.tracked}
          onApprove={props.onApprove}
          onApproveAll={props.onApproveAll}
          onNext={props.onNext}
          onPrevious={props.onPrevious}
          onRestyle={props.onRestyle}
          onRestyleAll={props.onRestyleAll}
        />
      </div>
    </div>
  );
}
